module.exports = __webpack_public_path__ + "static/img/vava.cff4df81.png";